import React from 'react';
import DashboardStatusButton from 'components/atoms/DashboardStatusButton';
import { Link } from 'react-router-dom';
import { IIncidentAgencySummary } from 'types/VehicleIncidents';
import { createCategoryAcronym } from 'utils/createCategoryAcronym';

export interface IDashboardIncidentAgencyBreakdownCard {
	className?: string;
	agencies: IIncidentAgencySummary[] | undefined;
	getExtraFilters?: () => { [key: string]: string | number };
}

const DashboardIncidentAgencyBreakdownCard: React.FC<
	IDashboardIncidentAgencyBreakdownCard
> = ({ className = '', agencies, getExtraFilters = () => ({}) }) => {
	//@ts-ignore
	const extraFilters: { [key: string]: string | number } = {
		...getExtraFilters(),
	};

	//@ts-ignore
	const urlString = new URLSearchParams(extraFilters).toString();
	const incidentPath = 'incidents';

	return (
		<table className={`${className} px-8 w-full`}>
			<thead className="border-b border-gray-200">
				<tr>
					<th className="text-secondary font-normal text-left pr-8 pb-3">
						Agency
					</th>
					<th className="text-secondary font-normal text-left pr-8 pb-3">
						Total
					</th>
					<th className="text-secondary font-normal text-left pr-8 pb-3">
						Status
					</th>
					<th className="text-secondary font-normal text-left pr-8 pb-3">
						Severity
					</th>
					<th className="text-secondary font-normal text-left pr-8 pb-3">
						Critical Action
					</th>
				</tr>
			</thead>
			<tbody>
				{agencies?.map((agency: IIncidentAgencySummary) => {
					const incident_total = (
						<Link
							to={`/${incidentPath}?incidentAgency=${agency.name}&${urlString}`}
						>
							{agency.statistics.total}
						</Link>
					);

					return (
						<tr
							className="border-b border-gray-200 py-4 font-normal font-scorpion-200"
							key={`agency-row-${agency.id}`}
						>
							<td className="pr-8 py-5 font-inter text-scorpion-500">
								{createCategoryAcronym(agency.name)}
							</td>
							<td className="pr-8 py-5 underline font-inter text-scorpion-500">
								{incident_total}
							</td>
							<td>
								<div className="pr-8 flex flex-row flex-wrap gap-y-2 gap-x-2 py-3">
									{['new', 'draft', 'submitted', 'open', 'closed'].map(
										(status) => {
											// @ts-ignore trust me bro
											if (agency.statistics[status] === 0) {
												return null;
											}

											const extraLinkQuery = `incidentAgency=${agency.name}&status=${status}&${urlString}`;

											return (
												<DashboardStatusButton
													key={`status-${agency.id}-${status}`}
													status={status}
													modulePath={incidentPath}
													// @ts-ignore trust me bro x2
													total={agency.statistics[status]}
													extraLinkQuery={extraLinkQuery}
													totalBrackets={true}
												/>
											);
										}
									)}
								</div>
							</td>
							<td>
								<div className="pr-8 flex flex-row flex-wrap gap-y-2 gap-x-2 py-3">
									{['Level 1', 'Level 2', 'Level 3', 'Level 4', 'Level 5'].map(
										(severity) => {
											// @ts-ignore trust me bro
											if (agency.statistics.severities[severity] === 0) {
												return null;
											}
											const extraLinkQuery = `incidentAgency=${agency.name}&severity=${severity}&${urlString}`;
											// get number from end of severity string
											const severityNumber = severity.match(/\d+/);
											return (
												<DashboardStatusButton
													key={`severity-${agency.id}-${severity}`}
													status={severityNumber?.toString() || ''}
													modulePath={incidentPath}
													// @ts-ignore trust me bro x2
													total={agency.statistics.severities[severity]}
													extraLinkQuery={extraLinkQuery}
													totalBrackets={true}
												/>
											);
										}
									)}
								</div>
							</td>
							<td>
								<div className="pr-8 flex flex-row flex-wrap gap-y-2 gap-x-2 py-3">
									{agency.statistics.actions['open'] > 0 && (
										<DashboardStatusButton
											status="Open"
											modulePath={incidentPath}
											total={agency.statistics.actions['open']}
											extraLinkQuery={`incidentAgency=${agency.name}&correctiveActions=open&${urlString}`}
											totalBrackets={true}
										/>
									)}
									{agency.statistics.actions['overdue'] > 0 && (
										<DashboardStatusButton
											status="Overdue"
											modulePath={incidentPath}
											total={agency.statistics.actions['overdue']}
											extraLinkQuery={`incidentAgency=${agency.name}&correctiveActions=overdue&${urlString}`}
											totalBrackets={true}
										/>
									)}
									{agency.statistics.actions['completed'] > 0 && (
										<DashboardStatusButton
											status="Complete"
											modulePath={incidentPath}
											total={agency.statistics.actions['completed']}
											extraLinkQuery={`incidentAgency=${agency.name}&correctiveActions=completed&${urlString}`}
											totalBrackets={true}
										/>
									)}
								</div>
							</td>
						</tr>
					);
				})}
			</tbody>
		</table>
	);
};

export default DashboardIncidentAgencyBreakdownCard;
